import {
  cacheExchange,
  createClient,
  errorExchange,
  fetchExchange,
} from "@urql/vue";
import { token } from "@/init";
import { reportGraphqlOperationError } from "@/graphql/graphqlErrorReporting";

export const sentryErrorExchange = errorExchange({
  onError: reportGraphqlOperationError,
});

export const client = createClient({
  url: "/graphql",
  fetchOptions: () => {
    const headers: HeadersInit = {};

    if (token.value) {
      headers["Authorization"] = `Bearer ${token.value}`;
    }

    return {
      headers,
    };
  },
  exchanges: [cacheExchange, sentryErrorExchange, fetchExchange],
});

export default client;
